// api =>
import backEnd from "../../services/api";

export const getCategoryList = async () => {
    try {
        const response = await backEnd.get('products/categories/');
        return response.data;
        
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}

export const getProductList = async (currentPage, filterUrl, categoryUrl) => {
    try {
        const response = await backEnd.get(`products/list/?page=${ currentPage }&category=${ categoryUrl }&environment_type=${ filterUrl }`);
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}
